<script>
    import user from './stores/user';
    import members from './stores/members';
    import groups from "./stores/groups";
    import {initApp} from "./requests";

    export let callback;

    let loading = true;
    const initializeApplication = async () => {
        const [err, res] = await initApp();

        if (err) {
            alert('error ' + err)
            return;
        }
        if (res.user && res.user.id) {
            res.user.app_name = res.user.name ? res.user.name : res.user.lastname;
            user.set(res.user);
            $members.list = res.members;
            $groups.list = res.groups;
            $groups.list.map(group => {
                group.id = parseInt(group.id);
                group.type = parseInt(group.type);
            })
        } else {
            user.set({ id: 0, session: null });
        }
        loading = false;

        callback();
    }

    initializeApplication();
</script>

{#if (loading)}
    <div class="initializer">
        <div class="logo">
            <img src="/assets/images/logo.png" alt="logo" />
        </div>
        <div class="caption">
            παρακαλώ περιμένετε...
        </div>
    </div>
{/if}